import { VerticalTabWorkList } from "../../secondary/VerticalTabWorkList";
import { useWorkListTabs } from "./hooks/useWorkListTabs";
import { WorklistScreen } from "./worklistScreen";
import { WORKLIST_CONFIG } from "./worklistConfig";

export function WoundExpert({ facilityNumber }) {
  const { dispatch, defaultVerTab, onSelectVerTab, piPoaCount, piNonPoaCount, sharpsurgicalDebridement } = useWorkListTabs(
    facilityNumber,
    "woundExpertValues"
  );

  const tabList = [
    {
      name: `POA ${piPoaCount}`,
      key: "poa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.woundExpertPOAStage} />,
      bottomName: "Pending Review",
    },
    {
      name: `Non-POA ${piNonPoaCount}`,
      key: "nonPoa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.woundExpertPOAStageUnstage} />,
      bottomName: "Pending Review",
    },
    {
      name: `Sharp/Surgical Debridement : Excisional Full Thickness ${sharpsurgicalDebridement}`,
      key: "sharpDebridment",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.woundExpertDebridement} />,
      bottomName: "Pending Review",
    },
  ];

  return (
    <VerticalTabWorkList onSelectInt={onSelectVerTab} defaultIndex={defaultVerTab <= 2 ? defaultVerTab : 0} tabList={tabList} dispatch={dispatch} />
  );
}
